"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var test_attributes_1 = require("@carvana/test-attributes");
var react_1 = require("react");
var styled_components_1 = __importStar(require("styled-components"));
var Sizes_1 = require("./Sizes");
var Variants_1 = require("./Variants");
var sharedStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  border-radius: ", ";\n  &:focus-visible {\n    box-shadow: 0px 0px 0px 3px rgba(34, 139, 230, 0.6),\n      0px 0px 0px 1px ", ";\n  }\n  width: ", ";\n  ", "\n  ", "\n  ", "\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"], ["\n  cursor: pointer;\n  border-radius: ", ";\n  &:focus-visible {\n    box-shadow: 0px 0px 0px 3px rgba(34, 139, 230, 0.6),\n      0px 0px 0px 1px ", ";\n  }\n  width: ", ";\n  ", "\n  ", "\n  ", "\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n"])), function (props) { return (props.$utility ? '8px' : helios_styles_1.borderRadius.round); }, helios_styles_1.shadow.focusVisible[1].color, function (props) { return props.$width; }, function (props) {
    var sizeStyles = props.$icon ? Sizes_1.sizeMap.icon[props.$size] : Sizes_1.sizeMap[props.$size];
    return sizeStyles || Sizes_1.sizeMap.md;
}, function (props) {
    var variantStyles = props.$utility
        ? Variants_1.variantMap.utility[props.$variant]
        : Variants_1.variantMap[props.$variant];
    return variantStyles || Variants_1.variantMap.primary;
}, function (props) {
    return (props.$icon || props.$utility) &&
        "display: flex;\n    align-items: center;\n    justify-content: center;";
});
var Btn = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  border: 0px;\n  outline: none;\n"], ["\n  ", "\n  border: 0px;\n  outline: none;\n"])), sharedStyles);
var Link = styled_components_1.default.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  min-height: 30px;\n  text-decoration: none;\n"], ["\n  ", "\n  min-height: 30px;\n  text-decoration: none;\n"])), sharedStyles);
exports.Button = (0, react_1.forwardRef)(function (_a, refs) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.type, type = _c === void 0 ? 'button' : _c, _d = _a.variant, variant = _d === void 0 ? 'primary' : _d, _e = _a.utility, utility = _e === void 0 ? false : _e, _f = _a.icon, icon = _f === void 0 ? false : _f, _g = _a.width, width = _g === void 0 ? 'auto' : _g, props = __rest(_a, ["children", "className", "onClick", "size", "type", "variant", "utility", "icon", "width"]);
    var getTestAttributes = (0, test_attributes_1.useTestFunc)();
    if ('href' in props) {
        return ((0, jsx_runtime_1.jsx)(Link, __assign({ className: className, "$size": size, "$variant": variant, "$utility": utility, "$icon": icon, "$width": width, ref: refs }, getTestAttributes('button'), props, { children: children })));
    }
    return ((0, jsx_runtime_1.jsx)(Btn, __assign({ className: className, onClick: onClick, "$size": size, type: type, "$variant": variant, "$utility": utility, "$icon": icon, "$width": width, ref: refs }, getTestAttributes('button'), props, { children: children })));
});
var templateObject_1, templateObject_2, templateObject_3;
